import React from 'react'
import AboutContent from '../componets/AboutContent';
import Footer from '../componets/Footer';

function About() {
  return (
    <div className="about-page">
      <AboutContent/>
      <Footer/>
      

    </div>
  )
}

export default About;